import moment from 'moment';

import { getReceivedSchedule } from 'utils/book-accommodation-and-activity/prepareReceivedDataMethods';
import { getSchedule } from 'utils/accommodations-and-activities/prepareReceivedActivityData';
import { getSummeryPriceForActivitySeveralDays } from '../book-accommodation-and-activity/totalPrice';
import { currencyFormatter } from '../prices/formatter';

export const BookedAddOns = addOns => {
  if (addOns.length !== 0) {
    return addOns
      .map(addOn => {
        return `${addOn.addOnCount} x ${addOn.addOn[0].title}`;
      })
      .join(' ⋅ ');
  }
  return '—';
};

export const BookedMandatoryFees = mandatoryFees => {
  if  (Array.isArray(mandatoryFees)&& (mandatoryFees.length !== 0)) {
    return mandatoryFees
      .map(mandatoryFee => {
        return `${mandatoryFee.mandatoryFee[0].title}`;
      })
      .join(' ⋅ ');
  }
  return '—';
};

export const guestsSumSeats = guestsInfo => {
  try {
    return guestsInfo
      .map(guests => guests.guestsNumber)
      .reduce(
        (guestsSum, actualGuestsNumber) => guestsSum + actualGuestsNumber
      );
  } catch {
    return 0;
  }
};

export const guestsDetailsInformation = (guestsInfo, t) => {
  return `${guestsInfo
    .map(guests => {
      return `${guests.guestsNumber.toString()} 
                               ${t(guests.participant[0].participant)}`;
    })
    .join(' ⋅ ')}`;
};

export const getAccommodationBookingSchedule = booking => {
  return `${booking.fromDate}, ${moment(
    booking.accommodation.checkInTime,
    'HH:mm:ssZZ'
  ).format('HH:mm')} - ${booking.toDate}, ${moment(
    booking.accommodation.checkOutTime,
    'HH:mm:ssZZ'
  ).format('HH:mm')}`;
};

export const getActivityBookingSchedule = booking => {
  if (!booking.startingDate) {
    return '—';
  }

  const startDate = booking.startingDate;
  const endDate = booking.endingDate;
  const checkInTime = booking.checkInTime
    ? `${moment(booking.checkInTime).format('HH:mm')}`
    : '—';

  const checkOutTime = booking.checkOutTime
    ? `${moment(booking.checkOutTime).format('YYYY-MM-DD')},
    ${moment(booking.checkOutTime).format('HH:mm')}`
    : '—';

  if (startDate && endDate) {
    return `${startDate} - ${endDate}`;
  }

  return `${startDate}, ${checkInTime} - ${checkOutTime}`;
};

export const isParticipantInfo = guestsInfo => {
  try {
    return guestsInfo[0].participant[0].participant !== '';
  } catch {
    return false;
  }
};

export const getActivityBookingTotalInfo = (data, isRelated) => {
  if (!data || !Object.keys(data).length) {
    return;
  }

  const totalInfo = {
    total: 0,
    currency: data?.payments[0]?.currency?.currency,
    type: 'activity',
    title: data.activity.title,
    guestsTotal: [],
    addOnsTotal: [],
    mandatoryFeesTotal: [],
    relatedBookings: []
  };

  data.bookedAddOns.forEach(addOn => {
    const addOnPrice = addOn.totalPrice / addOn.addOnCount;
    totalInfo.addOnsTotal.push({
      title: addOn.addOn[0].title,
      count: addOn.addOnCount,
      total: addOn.totalPrice,
      addOnPrice: addOnPrice.toFixed(2)
    });
    totalInfo.total += addOn.totalPrice;
  });

  // data.bookedMandatoryFees.forEach(mandatoryFee => {
  //   const mandatoryFeePrice = mandatoryFee.totalPrice / mandatoryFee.mandatoryFeeCount;
  //   totalInfo.mandatoryFeesTotal.push({
  //     title: mandatoryFee.mandatoryFee[0].title,
  //     count: mandatoryFee.mandatoryFeeCount,
  //     total: mandatoryFee.totalPrice,
  //     mandatoryFeePrice: mandatoryFeePrice.toFixed(2)
  //   });
  //   totalInfo.total += mandatoryFee.totalPrice;
  // });

  data.guests.forEach(guest => {
    const isActivitySeveralDays =
      data.activity.scheduleType === 'scheduleDateForm';

    if (isActivitySeveralDays && data.endingDate) {
      const multiDates = {
        startDate: moment(data.startingDate, 'YYYY-MM-DD'),
        endDate: moment(data.endingDate, 'YYYY-MM-DD')
      };
      const severalDaysTotal = getSummeryPriceForActivitySeveralDays(
        multiDates,
        guest.totalPrice
      );
      const severalDaysTotalCurrency = currencyFormatter(severalDaysTotal);
      const guestPrice =
        data.activity.pricesType === 'pricesFixedForm'
          ? guest.totalPrice
          : guest.totalPrice / guest.guestsNumber;
      totalInfo.guestsTotal.push({
        participant: guest.participant[0].participant,
        count: guest.guestsNumber,
        total: severalDaysTotalCurrency,
        guestPrice: guestPrice.toFixed(2)
      });
      totalInfo.total += severalDaysTotal;
    } else {
      const guestPrice =
        data.activity.pricesType === 'pricesFixedForm'
          ? guest.totalPrice
          : guest.totalPrice / guest.guestsNumber;
      totalInfo.guestsTotal.push({
        participant: guest.participant[0].participant,
        count: guest.guestsNumber,
        total: guest.totalPrice,
        guestPrice: guestPrice.toFixed(2)
      });
      totalInfo.total += guest.totalPrice;
    }
  });

  if (
    data.relatedAccommodationBooking &&
    data.relatedAccommodationBooking.length &&
    (!data.isCanceled || data.isCanceledWithMain)
  ) {
    const relatedData = data.relatedAccommodationBooking[0];
    if (!relatedData.isCanceled || relatedData.isCanceledWithMain) {
      totalInfo.relatedBookings.push(
        getAccommodationBookingTotalInfo(relatedData, true)
      );
    }
    totalInfo.relatedBookings.forEach(booking => {
      totalInfo.total += booking.total;
    });
  }

  if (!isRelated) totalInfo.total = totalInfo.total.toFixed(2);

  return totalInfo;
};

const getGuestsPrice = (prices, guest, nightsNumber, total) => {
  if (prices && prices.length && prices[0].day) {
    return guest.totalPrice;
  } else if (guest.participant[0].participant && guest.totalPrice) {
    return guest.totalPrice / (guest.guestsNumber * nightsNumber);
  } else {
    return (guest.totalPrice || total) / nightsNumber;
  }
};

export const getAccommodationBookingTotalInfo = (data, isRelated) => {
  if (!data || !Object.keys(data).length) {
    return;
  }
  const startDate = moment(data.fromDate, 'YYYY-MM-DD');
  const endDate = moment(data.toDate, 'YYYY-MM-DD');
  const nightsNumber = parseInt(endDate.diff(startDate, 'days'));

  const totalInfo = {
    total: 0,
    title: data.accommodation.title,
    nightsNumber: nightsNumber,
    type: 'accommodation',
    currency: data?.payments[0]?.currency?.currency,
    guestsTotal: [],
    addOnsTotal: [],
    mandatoryFeesTotal:[],
    relatedBookings: []
  };

  data.bookedAddOns.forEach(addOn => {
    const addOnPrice = addOn.totalPrice / addOn.addOnCount;
    totalInfo.addOnsTotal.push({
      title: addOn.addOn[0].title,
      count: addOn.addOnCount,
      total: addOn.totalPrice,
      addOnPrice: addOnPrice.toFixed(2)
    });
    totalInfo.total += addOn.totalPrice;
  });

  data.bookedMandatoryFees?.forEach(mandatoryFee => {
    const mandatoryFeePrice = mandatoryFee.totalPrice / mandatoryFee.mandatoryFeeCount;
    totalInfo.mandatoryFeesTotal.push({
      title: mandatoryFee.mandatoryFee[0].title,
      count: mandatoryFee.mandatoryFeeCount,
      total: mandatoryFee.totalPrice,
      mandatoryFeePrice: mandatoryFeePrice.toFixed(2)
    });
    totalInfo.total += mandatoryFee.totalPrice;
  });

  data.guests.forEach(guest => {
    const guestPrice = getGuestsPrice(
      data.accommodation.prices,
      guest,
      nightsNumber,
      totalInfo.total
    );
    totalInfo.guestsTotal.push({
      participant: guest.participant[0].participant,
      count: guest.guestsNumber,
      total: guest.totalPrice || totalInfo.total,
      guestPrice: guestPrice.toFixed(2)
    });
    totalInfo.total += guest.totalPrice || totalInfo.total;
  });

  if (
    data.relatedActivitiesBookings &&
    data.relatedActivitiesBookings.length &&
    (!data.isCanceled || data.isCanceledWithMain)
  ) {
    data.relatedActivitiesBookings.forEach(booking => {
      if (!booking.isCanceled || booking.isCanceledWithMain) {
        totalInfo.relatedBookings.push(
          getActivityBookingTotalInfo(booking, true)
        );
      }
    });
    totalInfo.relatedBookings.forEach(booking => {
      totalInfo.total += booking.total;
    });
  }

  if (!isRelated) totalInfo.total = totalInfo.total.toFixed(2);

  return totalInfo;
};

export const getRentalItemsBookingTotalInfo = (data ) => {  
  if (!data || !Object.keys(data).length) {
    return;
  }
  const startDate = moment(data.fromDate, 'YYYY-MM-DD');
  const endDate = moment(data.toDate, 'YYYY-MM-DD');
  const daysNumber = endDate.diff(startDate, 'days') + 1;


  const totalInfo = {
    total: 0,
    title: data.rentalItems.title,
    priceTypes: data.rentalItems.pricesType,
    daysNumber: daysNumber,
    type: 'Rental Items',
    currency: data?.payments[0]?.currency?.currency,
    unitsTotal: 0,
    unitsNumber: 0, 
    addOnsTotal: [],
  
  };

  data.bookedAddOns.forEach(addOn => {
    const addOnPrice = addOn.totalPrice / addOn.addOnCount;
    totalInfo.addOnsTotal.push({
      title: addOn.addOn[0].title,
      count: addOn.addOnCount,
      total: addOn.totalPrice,
      addOnPrice: addOnPrice.toFixed(2)
    });
    totalInfo.total += addOn.totalPrice;
  });

   if (data.units && data.units.length > 0) {
    totalInfo.unitsTotal = data.units[0].totalPrice;
    totalInfo.unitsNumber = data.units[0].unitsNumber; 
    totalInfo.total += data.units[0].totalPrice;
  }

  return totalInfo;
};


export const getCalendarActivitiesBookings = activities => {
  const bookings = [];
  const activitiesBookings = [];

  activities.map(item => {
    if (item.scheduleType === 'schedulePassForm') return;

    if (item.activityBookingsForPeriod.length) {
      activitiesBookings.push(...item.activityBookingsForPeriod);
    } else {
      const schedule = getSchedule(item);
      activitiesBookings.push({
        id: item.id,
        title: item.title,
        productCode: item.productCode,
        scheduleType: item.scheduleType,
        schedule: schedule[Object.keys(schedule)[0]],
        maxParticipants: item.maxParticipants,
        isPrivate: item.isPrivate,
        isWithoutBookings: true
      });
    }
  });

  activitiesBookings.map(item => {
    if (item.isWithoutBookings) {
      if (item.scheduleType === 'schedulePassForm') return;
      bookings.push(item);
      return;
    }

    if (!item.startingDate) return;

    const existedBookingIndex = bookings.findIndex(
      booking =>
        booking.activities &&
        booking.activities.find(
          activity => activity.activity.id === item.activity.id
        )
    );
    const scheduleData = getReceivedSchedule(item.schedule);

    if (existedBookingIndex >= 0) {
      const existedActivities = bookings[existedBookingIndex].activities;

      const existedActivityTimeIndex = existedActivities.findIndex(activity => {
        if (!scheduleData) return false;
        if (!activity.schedule) {
          if (
            activity.startingDate === item.startingDate &&
            !activity.endingDate &&
            !item.endingDate
          ) {
            return activity;
          }

          if (
            activity.startingDate === item.startingDate &&
            activity.endingDate === item.endingDate
          ) {
            return activity;
          }
          return false;
        }
        if (
          activity.startingDate === item.startingDate &&
          scheduleData.startTime &&
          activity.schedule.id === scheduleData.startTime.id
        ) {
          return activity;
        }
        return false;
      });

      if (existedActivityTimeIndex >= 0) {
        existedActivities[existedActivityTimeIndex].participants.push(item);
        existedActivities[existedActivityTimeIndex].guests.push(...item.guests);
        return;
      }

      existedActivities.push({
        ...item.activity,
        ...item,
        activity: { ...item.activity },
        startingDate: item.startingDate,
        schedule: scheduleData ? scheduleData.startTime : {},
        participants: [item],
        guests: [...item.guests],
        payments: [...item.payments],
        bookedAddOns: [...item.bookedAddOns],
        // bookedMandatoryFees: [...item.bookedMandatoryFees]
      });
      return;
    }

    const schedule = getSchedule(item.activity);

    bookings.push({
      id: item.id,
      title: item.activity.title,
      closestEvent: item.activity.closestEvent,
      productCode: item.activity.productCode,
      maxParticipants: item.activity.maxParticipants,
      isPrivate: item.activity.isPrivate,
      isOpen: item.activity.isOpen,
      activity: { ...item.activity },
      schedule: schedule[Object.keys(schedule)[0]],
      activities: [
        {
          ...item.activity,
          ...item,
          activity: { ...item.activity },
          startingDate: item.startingDate,
          schedule: scheduleData ? scheduleData.startTime : {},
          participants: [item],
          guests: [...item.guests],
          payments: [...item.payments],
          bookedAddOns: [...item.bookedAddOns],
          // bookedMandatoryFees: [...item.bookedMandatoryFees]
        }
      ]
    });
  });

  return bookings;
};

export const getCalendarAccommodationsBookings = accommodations => {
  const bookings = [];
  const accommodationsBookings = [];

  accommodations.map(item => {
    if (item.accommodationBookings.length) {
      accommodationsBookings.push(...item.accommodationBookings);
    } else {
      accommodationsBookings.push({
        id: item.id,
        title: item.title,
        photo:item.photo,
        productCode: item.productCode,
        fromDate: item.fromDate,
        toDate: item.toDate,
        isWithoutBookings: true
      });
    }
  });

  accommodationsBookings.map(item => {
    if (item.isWithoutBookings) {
      bookings.push(item);
      return;
    }
    const existedBookingIndex = bookings.findIndex(
      booking =>
        booking.accommodations &&
        booking.accommodations.find(
          accommodation =>
            accommodation.accommodation.id === item.accommodation.id
        )
    );
    if (existedBookingIndex >= 0) {
      bookings[existedBookingIndex].accommodations.push({
        ...item.accommodation,
        id: item.id,
        guestFirstName: item.guestFirstName,
        guestLastName: item.guestLastName,
        guestPhoneNumber: item.guestPhoneNumber,
        guestEmail:item.guestEmail,
        platform: item.platform,
        bookingNotes:item.bookingNotes,
        bookingType: item.bookingType,
        creationTime: item.creationTime,
        referenceNumber: item.referenceNumber,
        accommodation: { ...item.accommodation },
        fromDate: item.fromDate,
        toDate: item.toDate,
        isRelated: item.isRelated,
        guests: [...item.guests],
        payments: [...item.payments],
        bookedAddOns: [...item.bookedAddOns],
        bookedMandatoryFees: [...item.bookedMandatoryFees],
        relatedActivitiesBookings: [...item.relatedActivitiesBookings]
      });

      return;
    } else {
      bookings.push({
        id: item.accommodation.id,
        title: item.accommodation.title,
        photo: item.accommodation.photo,
        productCode: item.accommodation.productCode,
        fromDate: item.accommodation.fromDate,
        toDate: item.accommodation.toDate,
        accommodations: [
          {
            ...item.accommodation,
            id: item.id,
            accommodation: { ...item.accommodation },
            fromDate: item.fromDate,
            toDate: item.toDate,
            guestFirstName: item.guestFirstName,
            guestLastName: item.guestLastName,
            guestPhoneNumber: item.guestPhoneNumber,
            guestEmail:item.guestEmail,
            platform: item.platform,
            bookingType: item.bookingType,
            bookingNotes:item.bookingNotes,
            creationTime: item.creationTime,
            referenceNumber: item.referenceNumber,
            isRelated: item.isRelated,
            guests: [...item.guests],
            payments: [...item.payments],
            bookedAddOns: [...item.bookedAddOns],
            bookedMandatoryFees: [...item.bookedMandatoryFees],
            relatedActivitiesBookings: [...item.relatedActivitiesBookings]
          }
        ]
      });
    }
  });

  return bookings;
};
